import React from 'react';
import { Spinner } from './Spinner';

export const UiBlockingSpinner: React.FC<{ isBlocking?: boolean }> = ({ isBlocking = false, children }) => {
    return isBlocking ? <Spinner section>{children}</Spinner> : <>{children}</>;
};
